import { render } from "./Employee-Week-Overview.vue?vue&type=template&id=24d28844"
import script from "./Employee-Week-Overview.vue?vue&type=script&lang=js"
export * from "./Employee-Week-Overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__